import React from 'react';

import Code from '../base';

const codestring = `const fetch = require('node-fetch');

const username = '6d11075e-29ad-42b5-9bca-b5f278f9133c';
const password = 'UiHmmDOiUkH6c1b6VntTb4tzSy1jrCUha2N41DH73RY';

const business_id = '813c88b0fb668a0b7087be0550000fd0';
const account_id = '613b945a-2368-4dd1-9d83-b951bc77156d';
const batch_id = 'affe24a6-c7d6-4cf7-9984-3259b3055101';

const url = \`https://b2b-api.lana-staging.xyz/business/\${business_id}/accounts/\${account_id}/batches/\${batch_id}\`;
const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Basic ' + Buffer.from(\`\${username}:\${password}\`).toString('base64'),
};

const fetch_items = () => {
    fetch(url + '/items', { headers: headers }).then(response => {
        if (response.status !== 200) {
            throw Error(response.status);
        }

        return response.json()
    }).then(data => {
        console.log(data);
    });

};

fetch(url, { headers: headers }).then(response => {
    if (response.status !== 200) {
        throw Error(response.status);
    }

    fetch_items();
    return response.json()
}).then(data => {
    console.log(data);
});`;

const NodeFetchBatchDetails = () => <Code language="javascript" codestring={codestring} />;

export default NodeFetchBatchDetails;
